import React from "react"
import s from './teacher-card.module.scss'
import ContentLoader from "react-content-loader"

export const LoaderDesktop = (props) => (
	<ContentLoader
		speed={2}
		width="100%"
		height={260}
		viewBox="0 0 1170 260"
		className={s.loaderDesktop}
		backgroundColor="#FAFAFA"
		foregroundColor="#ebebeb"
		{...props}
	>
		<rect x="20" y="20" rx="12" ry="12" width="200" height="220" />
		<rect x="236" y="20" rx="8" ry="8" width="300" height="30" />
		<rect x="236" y="64" rx="6" ry="6" width="400" height="24" />
		<rect x="236" y="100" rx="5" ry="5" width="280" height="20" />
		<rect x="236" y="136" rx="4" ry="4" width="500" height="16" />
		<rect x="236" y="158" rx="4" ry="4" width="500" height="16" />
		<rect x="236" y="180" rx="4" ry="4" width="200" height="16" />
		<rect x="760" y="20" rx="8" ry="8" width="390" height="220" />
	</ContentLoader>
)
